export function request(id) {
    return {
        type: 'MARKETS_REMOVE_LIABILITIES_REQUEST',
        id
    };
}
